import React, { useState, useContext, useEffect } from 'react'
import { SaveOutlined } from '@ant-design/icons'
import { Modal, Form, Input, notification } from 'antd'
import { CounterContext } from 'redux/Golbalvalues'
import { addSchedule } from 'api/Reschedule/schedule'
import { getCookie } from 'helper/cookie'
import { useHistory } from 'react-router'
import lang from 'lang/en'
const { TextArea } = Input
const modalSaveRescd = (props) => {
  const {
    setVisibleModalSaveRescd,
    visibleModalSaveRescd,
    firstUpdate,
    FetchScheduleByid,
    getDataViewlog,
    getErrorflow,
    setOnChangeData,
    state,
  } = props
  const token = getCookie('access_token_admin')
  const language = getCookie('lang')
  const word = lang[language]
  const history = useHistory()
  const { setDirty, data_common_reschedule, click_path, setClick_path } = useContext(
    CounterContext,
  )
  const [form_reason] = Form.useForm()
  const handleSave = (val) => {
    setDirty(false)
    const data = {
      project_id: data_common_reschedule.project_id,
      kickoff: data_common_reschedule.kickoff,
      closure: data_common_reschedule.closure,
      reason: val.reason,
      sprintflow: data_common_reschedule.sprintflow,
    }
    try {
      addSchedule({
        params: data,
        id: data_common_reschedule.project_id,
        token: token,
      }).then((res) => {
        if (res.status === 200) {
          if (state === 'reschedule') {
            firstUpdate.current = true
            FetchScheduleByid()
            getDataViewlog()
            getErrorflow()
            setOnChangeData(false)
            openNotificationWithIcon('success', 'You saved success.')
          }
        }
      })
    } catch (error) {
      console.log(error)
    }
    if (click_path) {
      history.push(`${click_path}`)
      setClick_path()
    }
    setVisibleModalSaveRescd(false)
  }
  useEffect(() => {
    form_reason.setFieldsValue({
      reason: null,
    })
  }, [visibleModalSaveRescd])

  const openNotificationWithIcon = (type, des) => {
    notification[type]({
      // message: 'Task Informaion',
      description: des,
      duration: 2,
    })
  }

  return (
    <>
      <Modal
        maskClosable={false}
        className="ModalStatusOption"
        visible={visibleModalSaveRescd}
        okText={'OK'}
        onOk={form_reason.submit}
        onCancel={() => setVisibleModalSaveRescd(false)}
        cancelText={'Cancel'}
        destroyOnClose
      >
        <Form
          className="body-form"
          form={form_reason}
          onFinish={handleSave}
          name="form_reject"
        >
          <SaveOutlined className="Icon-style" />
          <h2>{word['title_save_reschedule']}</h2>
          <h4>{word['des_save_reschedule']}</h4>
          <Form.Item
            className="subform"
            id="reason"
            name="reason"
            rules={[
              {
                whitespace: true,
                required: true,
                message: '* Please tell a reason',
              },
            ]}
          >
            <TextArea
              id="reason"
              name="reason"
              placeholder="Please tell a reason"
              autoSize={{ minRows: 1, maxRows: 4 }}
            />
          </Form.Item>
        </Form>
      </Modal>
    </>
  )
}

export default modalSaveRescd
